import { useQuery } from '@tanstack/react-query'
import { useAPI } from '../../Contexts/APIContext'
import { useAuth } from '../../Contexts/AuthContext'

// Ask the same server authorizer used by ingestion itself. Do not infer global
// catalogue access from generic organization Owner/Administrator role names.
export default function useIngestAccess() {
  const api = useAPI()
  const { getCurrentUser } = useAuth()
  const user = getCurrentUser()
  return useQuery({ queryKey: ['ingest-access', user?.f_id || user?.email, user?.is_organization],
    queryFn: () => api.getIngestAccess(), enabled: !!user, retry: false,
    staleTime: 60000, refetchOnWindowFocus: false, refetchOnReconnect: false,
    meta: { suppressGlobalError: true } })
}
